/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIChannelCreationRequest
 */
export interface APIChannelCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreationRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIChannelCreationRequest
     */
    members: Array<string>;
}

/**
 * Check if a given object implements the APIChannelCreationRequest interface.
 */
export function instanceOfAPIChannelCreationRequest(value: object): value is APIChannelCreationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function APIChannelCreationRequestFromJSON(json: any): APIChannelCreationRequest {
    return APIChannelCreationRequestFromJSONTyped(json, false);
}

export function APIChannelCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIChannelCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'members': json['members'],
    };
}

export function APIChannelCreationRequestToJSON(value?: APIChannelCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'members': value['members'],
    };
}

